import React, { useState, useRef, useEffect } from "react";
import "../TerminalInput.css";

export default function TerminalInput({ onEnter }) {
  const [input, setInput] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter(input);
      setInput("");
    }
  };

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <div
      className="terminal-input"
      onClick={() => inputRef.current.focus()}
    >
      <span className="prompt">~$</span>
      <div className="terminal-wrapper">
        {/* Hidden actual input field */}
        <input
          ref={inputRef}
          className="hidden-input"
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          autoFocus
        />

        {/* Visible text and conditional blinking cursor */}
        <div className="terminal-typed">
          <span className="typed-text">{input}</span>
          {isFocused && <span className="custom-cursor" />}
        </div>
      </div>
    </div>
  );
}
